import { MutationOptions, useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import api from '../../api';
import { CustomerFormValues } from '@/types/customer-form-values';

type TData = void;
type TVariables = { orderId: string; customer: CustomerFormValues };

export function useUpdateOrderCustomerMutation(options?: UseMutationOptions<TData, Error, TVariables>) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['update-order-customer'],
    mutationFn: ({ orderId, customer }: TVariables) => api.order.updateCustomer(orderId, customer),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['orders'],
      });
    },
    ...options,
  });
}
